import { memo } from "react";
import BidButton from "./BidButton";

const CardBidButton = ({ isRecommendedProperties, item, cardIndex, style }) => {
  
  if (item?.category === "FORECLOSURE" && item?.propertyStatus !== "AUCTION_EVENT_ENDED" && item?.isFcProxyBidEnabled && item?.fcProxyBidCutOffAvailable && item?.onWatchList === "Y") {
    return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
  } else {
    if ((item?.category === "FORECLOSURE" && item?.fcOnlineFlag === "N") || item?.isPreview || (item?.listingType === "TRNL" && (item?.propertyStatus === "WFA" || item?.propertyStatus === "PREVIEW"))) {
      return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
    } else if (item?.category === "NPL") {
      return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
    } else {
      if (item?.listingType === 'AUCN') {
        if (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") {
          if (item?.auctionTimeLeft > 0) {
            if (item?.onWatchList === 'Y' || item?.isPlaceBidEnabled === 'Y') {
              return <BidButton title={'Place Bid'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
            } else {
              return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
            }
          } else {
            return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
          }
        } else if (item?.propertyStatus === 'PACT' || item?.propertyStatus === 'WFA' || item?.listingStatus === 'Pending' || item?.listingDetailStatus === 'CANCELLED') {
          return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
        }
        if (item?.tagName === 'UnderContract' || item?.tagName === 'UnderReview') {
          return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
        }
      }
      if (item?.listingType === 'TRNL') {
        if (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") {
          if (item?.onWatchList === 'Y' || item?.isPlaceBidEnabled === 'Y') {
            return <BidButton title={'Place Offer'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
          } else {
            return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
          }
        }
        if (item?.tagName === 'UnderContract' || item?.tagName === 'UnderReview') {
          return <BidButton title={'View Details'} isRecommendedProperties={isRecommendedProperties} item={item} cardIndex={cardIndex} style={style} />
        }
      }
    }
  }
};
export default memo(CardBidButton);